import React from 'react'

const Manual_invuKDS_comandas = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          InvuKDS - Comandas
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía proporciona información esencial sobre el uso del sistema InvuKDS, optimizando la
          gestión de pedidos en la cocina. Destaca funciones clave como marcar artículos como preparados,
          priorizar pedidos y rastrear su estado en múltiples estaciones, mejorando la eficacia y la
          coordinación para optimizar la prestación del servicio.
        </p>
        <iframe
          src="https://scribehow.com/embed/InvuKDS__Comandas__om4maXVNRUK3F-GlfFr2dw?as=scrollable"
          className="scribe-iframe-general-9"
          width="100%"
          height="6900"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_invuKDS_comandas